import { Spinner } from 'react-bootstrap';
import { Grid, RotatingLines, ThreeDots, Triangle } from 'react-loader-spinner';

const Loading = () => {
    return (
        <div style={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/* <Triangle
                visible={true}
                height="90"
                width="90"
                color="#3688fc"
                ariaLabel="triangle-loading"
                wrapperStyle={{}}
                wrapperClass=""
            /> */}
            <Grid
                visible={true}
                height="90"
                width="90"
                color="#3688fc"
                ariaLabel="grid-loading"
                radius="12.5"
                wrapperStyle={{}}
                wrapperClass="grid-wrapper"
            />
            {/* <RotatingLines
                strokeColor="grey"
                strokeWidth="4"
                animationDuration="0.75"
                width="100"
                visible={true}
            /> */}
        </div>
    );
};

const ButtonLoading = () => {
    return (
        <div className=" d-flex justify-content-center align-items-center w-100">
            <Spinner animation="border" role="status" style={{ height: '1.3rem', width: '1.3rem' }}></Spinner>
        </div>
    );
};
const InputLoader = () => {
    return (
        <ThreeDots
            visible={true}
            height="30"
            width="40"
            color="rgb(1, 51, 161)"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
        />
    )
}

export { Loading, ButtonLoading, InputLoader };
